import { useMemo } from "react";
import { Box, Typography } from "@mui/material";

export const formTitleStyles = {
  fontFamily: "Inter",
  fontWeight: "600",
  fontSize: "16px",
};

export const locationStyle = {
  whiteSpace: "pre-wrap",
  margin: "0",
};

const UserDetailInfo = ({ getValues, watch }) => {
  const deliveryLocation = useMemo(
    () => getValues("deliveryLocation"),
    [watch("deliveryLocation")]
  );
  const contactNumber = useMemo(
    () => getValues("contactNumber"),
    [watch("contactNumber")]
  );
  return deliveryLocation ? (
    <Box sx={{ padding: "16px", backgroundColor: "#EDF1F3" }}>
      <Box sx={{ marginBottom: "12px" }}>
        <Typography variant="h6" component="h2" sx={formTitleStyles}>
          Mailing Address
        </Typography>
        <Box>
          <p style={locationStyle}>{deliveryLocation.mailingAddress}</p>
          <p style={locationStyle}>
            {deliveryLocation.city} - {deliveryLocation.postalCode}
          </p>
          <p style={locationStyle}>{deliveryLocation.state}</p>
          <p style={locationStyle}>{deliveryLocation.country}</p>
        </Box>
      </Box>
      {contactNumber && (
        <Box>
          <Typography variant="h6" component="h2" sx={formTitleStyles}>
            Contact
          </Typography>
          <p style={locationStyle}>{contactNumber}</p>
        </Box>
      )}
    </Box>
  ) : null;
};

export default UserDetailInfo;
